import { qs, gtag, getExperimentID } from './util';

window.addEventListener('scroll', () => {
  const doc = document.documentElement,
    top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  if (
    top >= 280 &&
    sessionStorage.getItem('experimentId') === 'Floating_Signup_Experiment3'
  ) {
    qs('.floating-signup a').style.display = 'inline-block';
  } else {
    qs('.floating-signup a').style.display = 'none';
  }
  if (
    innerWidth <= 767 &&
    top >= 250 &&
    sessionStorage.getItem('experimentId') === 'Floating_Signup_Experiment3'
  ) {
    qs('#fake-chat-icon').style.display = 'none';
  } else {
    qs('#fake-chat-icon').style.display = 'block';
  }
});

function runExperiment(prodKey, betaKey) {
  gtag('event', 'optimize.callback', {
    name: getExperimentID(
      prodKey, //Prod Key
      betaKey //Beta key
    ),
    callback: value => {
      if (value === '0') {
        sessionStorage.setItem(
          'experimentId',
          'Floating_Signup_Experiment3_Unactivated'
        );
      } else if (value === '1') {
        sessionStorage.setItem('experimentId', 'Floating_Signup_Experiment3');
      }
    }
  });
}

if (location.pathname === '/payment-buttons/') {
  runExperiment(
    'G7GyD3MNSpKtxK3_ao0ggA', //Prod Key
    '_w2pa0OMRXOB6x_ZuYNW9w' //Beta key
  );
} else if (location.pathname === '/payment-pages/') {
  runExperiment(
    'tH8aEczkQBWyJbpCfxxTFA', //Prod Key
    '_w2pa0OMRXOB6x_ZuYNW9w' //Beta key
  );
}
